import OrderableTypes from "../Orders/OrderableTypes";
import SystemItemTypes from "../Orders/SystemItemTypes";
import OrderSources from "../Orders/OrderSources";

/**
 * We have to have this utility class because most of the enums
 * were originally exported as plain javascript objects
 */

class UiLabel {

	// Orders/OrderableType.php
	static OrderableTypes = OrderableType => {
		switch (OrderableType) {
			case OrderableTypes.ProductHOPS:
				return "HOPS";
			case OrderableTypes.Membership:
				return "Membership";
			case OrderableTypes.RailwayProduct:
				return "Product";
			case OrderableTypes.TicketTravel:
				return "Travel Ticket";
			case OrderableTypes.TicketSession:
				return "Event Ticket";
			case OrderableTypes.SeatReservation:
				return "Seat Reservation";
			case OrderableTypes.VoucherSale:
				return "Voucher";
			case OrderableTypes.Shares:
				return "Shares";
			case OrderableTypes.DeliveryMethod:
				return "Delivery";
			case OrderableTypes.System:
				return "Miscellaneous";
			default:
				return "Unknown";
		}
	};

	static SystemItemTypes = SystemItemType => {
		switch (SystemItemType) {
			case SystemItemTypes.VoucherBalancingSale:
				return "Voucher Balancing Sale";
			case SystemItemTypes.UnknownPlaceholder:
				return "Unknown Placeholder";
			case SystemItemTypes.NoSale:
				return "No Sale";
			case SystemItemTypes.Generic:
				return "Generic";
			default:
				return "Unknown";
		}
	};

	static OrderSources = OrderSource => {
		switch (OrderSource) {
			case OrderSources.Unknown:
				return "Unknown";
			case OrderSources.Hops:
				return "HOPS";
			case OrderSources.Local:
				return "Online";
			case OrderSources.Pos:
				return "POS";
			case OrderSources.Moto:
				return "Mail Order / Telephone Order (MOTO)";
			case OrderSources.RecordedByOrg:
				return "Recorded by Organisation";
			case OrderSources.BalancingPayment:
				return "Automatic Balancing Payment";
			default:
				return "Unknown";
		}
	};

}

export default UiLabel;
